import React, { memo, useCallback } from 'react'
import tw from 'twin.macro'
import { CancelSmallMinor, CustomersMinor } from '@shopify/polaris-icons'
import { Typography, Tooltip } from '@mui/material'
import { cutLongWord } from 'src/utils/baseUtils'
import { RelationContractor } from 'src/interfaces/mcLite'

interface Props {
  subcontractor: RelationContractor
  hideRemove?: boolean
  onRemove(subcontractor: RelationContractor): void
}

const RemovableMCLiteSubcontractorComponent = ({ subcontractor, hideRemove, onRemove }: Props) => {
  const handleRemove = useCallback(() => {
    onRemove(subcontractor)
  }, [subcontractor, onRemove])

  const title = `${subcontractor.name} • ID ${subcontractor.externalId}`
  const shouldShowTooltip = title.length > 40

  return (
    <div css={tw`bg-[#EDEDED] rounded flex py-1 px-2`}>
      <CustomersMinor css={tw`self-center`} width={20} height={20} />
      {shouldShowTooltip ? (
        <Tooltip title={title} arrow>
          <Typography variant="subtitle1" css={tw`mx-1 my-0`}>
            {cutLongWord(title, 40)}
          </Typography>
        </Tooltip>
      ) : (
        <Typography variant="subtitle1" css={tw`mx-1 my-0`}>
          {cutLongWord(title, 40)}
        </Typography>
      )}
      {!hideRemove && (
        <div css={tw`h-5 cursor-pointer hover:opacity-50`} onClick={handleRemove}>
          <CancelSmallMinor width={20} />
        </div>
      )}
    </div>
  )
}

export const RemovableMCLiteSubcontractor = memo(RemovableMCLiteSubcontractorComponent)
